import type { FunctionComponent } from "react";
import * as S from "../style";
import type { Option } from "../types";
import { t } from "i18next";

interface Props {
  application?: Option;
}

export const Placeholder: FunctionComponent<Props> = ({ application }) => {
  return (
    <S.PlaceholderWrapper>
      <S.ImportText>{t("import.import-in")} : </S.ImportText>
      {application === undefined ? (
        <S.GrayedText>&#123; app-name &#125; </S.GrayedText>
      ) : (
        <S.Text>{application.label}</S.Text>
      )}
    </S.PlaceholderWrapper>
  );
};
